// extracted by mini-css-extract-plugin
export default {"two-factor__switch":"TwoFactorModal_two-factor__switch__6mKjM","row":"TwoFactorModal_row__S3oX7"};